/* eslint-disable @typescript-eslint/no-namespace, @typescript-eslint/naming-convention, no-restricted-syntax -- This module is the centralized web env-variable boundary required by NX-9571. */
export const WEB_APP_VERSION = typeof APP_VERSION === "string" ? APP_VERSION : undefined;
export const WEB_BUILD_MODE = process.env.VITE_MODE;
export const WEB_API_URL = process.env.VITE_API_URL;
export const WEB_ASSETS_URL = process.env.VITE_ASSETS_URL;
export const WEB_ATTRIBUTION_SIGNING_SECRET = process.env.VITE_ATTRIBUTION_SIGNING_SECRET;
export const WEB_FIREBASE_API_KEY = process.env.VITE_FIREBASE_API_KEY;
export const WEB_FIREBASE_APP_ID = process.env.VITE_FIREBASE_APP_ID;
export const WEB_FIREBASE_AUTH_DOMAIN = process.env.VITE_FIREBASE_AUTH_DOMAIN;
export const WEB_FIREBASE_MESSAGING_SENDER_ID = process.env.VITE_FIREBASE_MESSAGING_SENDER_ID;
export const WEB_FIREBASE_PROJECT_ID = process.env.VITE_FIREBASE_PROJECT_ID;
export const WEB_FIREBASE_STORAGE_BUCKET = process.env.VITE_FIREBASE_STORAGE_BUCKET;
export const WEB_JWT_PUBLIC_KEY = process.env.VITE_JWT_PUBLIC_KEY;
export const WEB_KINDE_CLIENT_ID = process.env.VITE_KINDE_CLIENT_ID;
export const WEB_KINDE_DOMAIN = process.env.VITE_KINDE_DOMAIN;
export const WEB_KINDE_ORG = process.env.VITE_KINDE_ORG;
export const WEB_KINDE_USE_LOCAL_STORAGE = process.env.VITE_KINDE_USE_LOCAL_STORAGE;
export const WEB_LOAD_AS_APPLICATION_ID = process.env.VITE_LOAD_AS_APPLICATION_ID;
export const WEB_LOGROCKET_STAGING = process.env.VITE_LOGROCKET_STAGING;
export const WEB_PUBLIC_KINDE_CONNECTION_APPLE = process.env.VITE_PUBLIC_KINDE_CONNECTION_APPLE;
export const WEB_PUBLIC_KINDE_CONNECTION_DISCORD = process.env.VITE_PUBLIC_KINDE_CONNECTION_DISCORD;
export const WEB_PUBLIC_KINDE_CONNECTION_EMAIL_PASSWORDLESS = process.env.VITE_PUBLIC_KINDE_CONNECTION_EMAIL_PASSWORDLESS;
export const WEB_PUBLIC_KINDE_CONNECTION_GOOGLE = process.env.VITE_PUBLIC_KINDE_CONNECTION_GOOGLE;
export const WEB_PUBLIC_KINDE_CONNECTION_X = process.env.VITE_PUBLIC_KINDE_CONNECTION_X;
export const WEB_QUEUE_RETRY_TIME_SECONDS = process.env.VITE_QUEUE_RETRY_TIME_SECONDS;
export const WEB_RECOMBEE_DB_NAME = process.env.VITE_RECOMBEE_DB_NAME;
export const WEB_RECOMBEE_PUBLIC_TOKEN = process.env.VITE_RECOMBEE_PUBLIC_TOKEN;
export const WEB_RECOMBEE_REGION = process.env.VITE_RECOMBEE_REGION;
export const WEB_RECOMBEE_REQUEST_TIMEOUT_LOCAL_STORAGE = process.env.VITE_RECOMBEE_REQUEST_TIMEOUT_LOCAL_STORAGE;
export const WEB_RESET_3RD_PARTIES = process.env.VITE_RESET_3RD_PARTIES;
export const WEB_SOCKET_SERVER = process.env.VITE_SOCKET_SERVER;
export const WEB_TRACKJS_APPLICATION = process.env.VITE_TRACKJS_APPLICATION;
export const WEB_TRACKJS_TOKEN = process.env.VITE_TRACKJS_TOKEN;
export const WEB_TYPESENSE_FALLBACK_HOST_1 = process.env.VITE_TYPESENSE_FALLBACK_HOST_1;
export const WEB_TYPESENSE_FALLBACK_HOST_2 = process.env.VITE_TYPESENSE_FALLBACK_HOST_2;
export const WEB_TYPESENSE_FALLBACK_HOST_3 = process.env.VITE_TYPESENSE_FALLBACK_HOST_3;
export const WEB_TYPESENSE_FALLBACK_HOST_4 = process.env.VITE_TYPESENSE_FALLBACK_HOST_4;
export const WEB_TYPESENSE_FALLBACK_HOST_5 = process.env.VITE_TYPESENSE_FALLBACK_HOST_5;
export const WEB_TYPESENSE_HOST = process.env.VITE_TYPESENSE_HOST;
export const WEB_WITH_CREDENTIALS = process.env.VITE_WITH_CREDENTIALS;
